import { render, staticRenderFns } from "./veStuAssocLabelEdit.vue?vue&type=template&id=e0634730&scoped=true"
import script from "./veStuAssocLabelEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocLabelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0634730",
  null
  
)

export default component.exports